<template>
	<div class="grid-box" :style="style">
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		justify: String,
		align: String,
		columns: String,
		rows: String,
		gap: String
	},
	// setup(props, { emit, slots, attrs }) {},
	data() {
		return {}
	},
	computed: {
		style() {
			const { justify, align, columns, rows, gap } = this
			return {
				justifyItems: justify,
				alignItems: align,
				gridTemplateColumns: columns,
				gridTemplateRows: rows,
				gap
			}
		}
	},
	mounted() {},
	methods: {},
	components: {}
}
</script>

<style lang="scss" scoped="scoped">
.grid-box {
	display: grid;
}
</style>
